/* DUNKPOINT quick add: the basket icon on a product card opens a drawer on the
   right (a sheet from the bottom on phones), so the product can be added
   without leaving the page. The option pickers use the product page's own
   markup and classes. */
(function () {
  'use strict';

  /* Translated labels, printed by snippets/dp-strings.liquid. */
  var S = window.dpStrings || {};
  var STOCK_LINE = S.qaStock || 'Limited Stock, Order before it’s gone';
  var SHIPPING_LINE = S.qaShipping || 'Free tracked shipping';
  var OPTION_PREFIX = S.qaChoose || 'Choose your';
  var ADD_LABEL = S.qaAddToCart || 'Add to Cart';
  var MAX_PILLS = 10;

  var root = null;
  var product = null;
  var chosen = [];
  var busy = false;

  function money(cents) {
    if (typeof window.dpMoney === 'function') return window.dpMoney(cents);
    return (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(src, width) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function optionNames() {
    return (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
  }

  /* Size first, the same order as the product page. */
  function orderedIndexes() {
    var names = optionNames();
    var order = [];
    names.forEach(function (name, i) { if (/size|tama|talla|taille/i.test(name)) order.push(i); });
    names.forEach(function (name, i) { if (order.indexOf(i) < 0) order.push(i); });
    return order;
  }

  function valuesFor(index) {
    var seen = [];
    product.variants.forEach(function (v) {
      var value = v['option' + (index + 1)];
      if (value && seen.indexOf(value) < 0) seen.push(value);
    });
    return seen;
  }

  function findVariant(values) {
    return product.variants.filter(function (v) {
      return values.every(function (value, i) { return v['option' + (i + 1)] === value; });
    })[0];
  }

  function canPick(index, value) {
    var test = chosen.slice();
    test[index] = value;
    var match = findVariant(test);
    return !!(match && match.available);
  }

  function build() {
    root = document.createElement('div');
    root.className = 'dp dp-qa';
    root.innerHTML =
      '<div class="dp-qa__scrim" data-qa-close></div>' +
      '<aside class="dp-qa__panel" role="dialog" aria-modal="true" aria-label="' + esc(S.qaTitle || 'Quick add') + '"><div data-qa-content></div></aside>';
    document.body.appendChild(root);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) { close(); return; }
      var pill = e.target.closest('[data-qa-pill]');
      if (pill) {
        chosen[Number(pill.getAttribute('data-qa-opt'))] = pill.getAttribute('data-qa-pill');
        renderPanel();
        return;
      }
      if (e.target.closest('[data-qa-add]')) add();
    });
    root.addEventListener('change', function (e) {
      var select = e.target.closest('[data-qa-select]');
      if (!select) return;
      chosen[Number(select.getAttribute('data-qa-opt'))] = select.value;
      renderPanel();
    });
  }

  function renderPanel() {
    var names = optionNames();
    var variant = findVariant(chosen) || product.variants[0];
    var images = (product.images || []).slice(0, 2);
    var compare = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;

    /* Grab handle: only shown on phones, where the panel is a bottom sheet. */
    var html = '<span class="dp-qa__grab" aria-hidden="true"></span>';

    if (images.length) {
      html += '<div class="dp-qa__media">' + images.map(function (src) {
        return '<img src="' + esc(sized(src, 500)) + '" alt="">';
      }).join('') + '</div>';
    }

    /* dp-pdp--v2 is what the product page's option styling hangs off, so the
       pickers in here look exactly like the ones on the product page. */
    html += '<div class="dp-qa__body dp-pdp--v2">' +
      '<div class="dp-qa__head">' +
      '<h2 class="dp-qa__title">' + esc(product.title) + '</h2>' +
      '<button type="button" class="dp-qa__x" data-qa-close aria-label="' + esc(S.close || 'Close') + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button></div>' +
      '<div class="dp-qa__prices">' +
      (compare ? '<s>' + money(compare) + '</s>' : '') +
      '<b>' + money(variant.price) + '</b></div>';

    if (!(product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
      orderedIndexes().forEach(function (index) {
        var values = valuesFor(index);
        if (values.length < 2) return;
        html += '<div class="dp-opt">' +
          '<div class="dp-opt__head">' +
          '<span class="dp-opt__label">' + esc(OPTION_PREFIX) + ' ' + esc(names[index]) +
          ': <strong>' + esc(chosen[index] || '') + '</strong></span>' +
          '</div>';
        if (values.length > MAX_PILLS) {
          html += '<select class="dp-opt__select" data-qa-select data-qa-opt="' + index + '" aria-label="' + esc(names[index]) + '">' +
            values.map(function (value) {
              return '<option value="' + esc(value) + '"' + (chosen[index] === value ? ' selected' : '') + '>' + esc(value) + '</option>';
            }).join('') + '</select>';
        } else {
          html += '<div class="dp-opt__pills" role="group" aria-label="' + esc(names[index]) + '">' +
            values.map(function (value) {
              var on = chosen[index] === value;
              var off = !canPick(index, value);
              return '<button type="button" class="dp-pill' + (on ? ' is-selected' : '') + (off ? ' is-unavailable' : '') +
                '" data-qa-opt="' + index + '" data-qa-pill="' + esc(value) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
                esc(value) + '</button>';
            }).join('') + '</div>';
        }
        html += '</div>';
      });
    }

    var sellable = variant && variant.available;
    html += '<p class="dp-qa__stock"><i aria-hidden="true"></i>' + esc(STOCK_LINE) + '</p>' +
      '<button type="button" class="dp-qa__atc" data-qa-add' + (sellable ? '' : ' disabled') + '>' +
      esc(sellable ? ADD_LABEL : (S.qaSoldOut || 'Sold out')) + '</button>' +
      '<p class="dp-qa__meta">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H3v12a2 2 0 0 0 2 2h9Z"/><path d="M14 9h4l3 3v6h-7"/><circle cx="7.5" cy="18.5" r="1.5"/><circle cx="17.5" cy="18.5" r="1.5"/></svg>' +
      esc(SHIPPING_LINE) + '</p>' +
      '<a class="dp-qa__more" href="/products/' + esc(product.handle) + '">' + esc(S.qaFullDetails || 'Full details and personalisation') + '</a>' +
      '</div>';

    root.querySelector('[data-qa-content]').innerHTML = html;
  }

  function open(handle) {
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) { window.location.href = '/products/' + handle; return; }
        product = data;
        var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
        chosen = [first.option1, first.option2, first.option3].filter(function (v) { return v != null; });
        if (!root) build();
        renderPanel();
        root.querySelector('.dp-qa__panel').scrollTop = 0;
        root.classList.add('is-open');
        document.body.classList.add('dp-cart-open');
      })
      .catch(function () { window.location.href = '/products/' + handle; });
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('dp-cart-open');
  }

  function add() {
    if (busy) return;
    var variant = findVariant(chosen);
    if (!variant || !variant.available) return;
    busy = true;
    var button = root.querySelector('[data-qa-add]');
    if (button) { button.disabled = true; button.textContent = S.qaAdding || 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function () {
        close();
        var opener = document.getElementById('DpCartOpener');
        if (opener) opener.click();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (button) { button.disabled = false; button.textContent = ADD_LABEL; }
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.dp-card__quick');
    if (!trigger) return;
    var card = trigger.closest('.dp-card');
    if (!card) return;
    var href = card.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(match[1]);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && root.classList.contains('is-open')) close();
  });
})();
